import React from 'react';
import { AdmissionData } from '../../types';

import AdmissionPage from './AdmissionPage';
import ServiceAgreementPage from './ServiceAgreementPage';
import Schedule1Page from './Schedule1Page';
import Schedule2Page from './Schedule2Page';
import Schedule3Page from './Schedule3Page';
import AcceptancePage from './AcceptancePage';
import PDAPage from './PDPAPage';

interface ReportViewProps {
  data: AdmissionData;
}

const ReportSection: React.FC<{ title: string; children: React.ReactNode, isFirst?: boolean }> = ({ title, children, isFirst = false }) => (
  <div className={`${isFirst ? '' : 'page-break-before-always'} print:mb-6`}>
    <header className="mb-8 text-center print:mb-4">
      <img src="https://mycareconcierge.com/wp-content/uploads/2024/10/care_concierge_logo_300x300.png" alt="Care Concierge Logo" className="h-20 w-auto mx-auto mb-4 print:h-12 print:mb-2" />
      <h1 className="text-3xl font-bold text-slate-800 border-b-2 border-slate-200 pb-4 print:text-xl print:pb-2">{title}</h1>
    </header>
    {children}
  </div>
);

const ReportView: React.FC<ReportViewProps> = ({ data }) => {
  const commonProps = {
    data,
    onUpdate: async () => { },
    isSaving: false,
    isClientView: false, // Show all fields
    isPrintView: true,
  };

  const dummyContinue = () => { };
  const dummyAccept = () => { };

  return (
    <div className="bg-white p-4 font-sans text-sm print:p-0">
      <ReportSection title="Resident Admission Form" isFirst>
        <AdmissionPage {...commonProps} onContinue={dummyContinue} />
      </ReportSection>
      <ReportSection title="Service Agreement">
        <ServiceAgreementPage onContinue={dummyContinue} isPrintView />
      </ReportSection>
      <ReportSection title="Service Agreement - Schedule 1">
        {/* FIX: Add missing onContinue prop */}
        <Schedule1Page {...commonProps} onContinue={dummyContinue} />
      </ReportSection>
      <ReportSection title="Service Agreement - Schedule 2">
        {/* FIX: Add missing onContinue prop */}
        <Schedule2Page {...commonProps} onContinue={dummyContinue} />
      </ReportSection>
      <ReportSection title="Service Agreement - Schedule 3">
        {/* FIX: Add missing onContinue prop */}
        <Schedule3Page {...commonProps} onContinue={dummyContinue} />
      </ReportSection>
      <ReportSection title="Service Agreement - Acceptance">
        <AcceptancePage {...commonProps} onAccept={dummyAccept} />
      </ReportSection>
      <ReportSection title="PDPA Consent Form">
        <PDAPage {...commonProps} onAccept={dummyAccept} />
      </ReportSection>
    </div>
  );
};

export default ReportView;